import { useEffect } from "react";
import axios from "axios";

const useIpLocation = (onError, onSuccess, isNonUkForced) => {
  useEffect(() => {
    (async () => {
      let ipApiRes;

      try {
        ipApiRes = await axios.get(`https://pro.ip-api.com/json/?key=${process.env.REACT_APP_IP_API_KEY}`);
      } catch (error) {
        if (onError) {
          onError(error);
        }
      }

      let countryCodeApiRes,
          countryList = [];

      try {
        countryCodeApiRes = await axios.get("/countries-phone-codes");
        countryList = countryCodeApiRes?.data?.data;
      } catch (error) {
        if (onError) {
          onError(error);
        }
      }

      const country = ipApiRes?.data?.country;
      const {
        countryCode
      } = ipApiRes?.data;
      console.log("country", country);
      const isNonUk = isNonUkForced || country.indexOf("United Kingdom") < 0 && country.indexOf("Ireland") < 0;
      let dialingCode = countryList.find(obj => obj.code === countryCode)?.callingCode;

      if (onSuccess) {
        onSuccess({
          country,
          dialingCode,
          isNonUk
        });
      }
    })();
  }, []);
  return [];
};

export default useIpLocation;